import { render } from "./Tabla-Pagos.vue?vue&type=template&id=94119260&scoped=true"
import script from "./Tabla-Pagos.vue?vue&type=script&lang=js"
export * from "./Tabla-Pagos.vue?vue&type=script&lang=js"

import "./Tabla-Pagos.vue?vue&type=style&index=0&id=94119260&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94119260"]])

export default __exports__